import "./TopNavigationTemplate.html";
export var template: string = require('./TopNavigationTemplate.html');

import ko = require('knockout');
import { PubSub, Subscriptions } from "Subscriptions";
import ClientSession from "ClientSession";
import SecurityService from "Services/SecurityService";
import RootStore from "Stores/RootStore";

class TopNavigationViewModel {
    product: KnockoutObservable<string>;
    fullName: KnockoutObservable<string>;
    facilityName: KnockoutObservable<string>;
    profileMenu: KnockoutObservableArray<any>;
    enableNavigation: KnockoutObservable<boolean>;

    facilityMenuReady: KnockoutObservable<boolean>;
    facilityMenuReadySubscription: KnockoutSubscription;
    profileMenuReady: KnockoutObservable<boolean>;
    profileMenuReadySubscription: KnockoutSubscription;
    userFullName: KnockoutObservable<string>;

    editingCriticalFields: KnockoutObservable<boolean>;

    meaningfulUseConfigured: KnockoutObservable<boolean>;
    securityService: SecurityService;

    //Subscriptions
    settingsSubmittedSubscription: string;


    constructor(params: any) {
        this.product = ko.observable(params.product);
        this.fullName = ko.observable(params.fullName);
        this.facilityName = ko.observable(params.facilityName);
        this.profileMenu = ko.observableArray(params.profileMenu);
        this.enableNavigation = ko.observable(params.enableNavigation);
        this.userFullName = ko.observable(params.userFullName);

        this.facilityMenuReady = ko.observable(false);
        this.facilityMenuReadySubscription = this.facilityMenuReady.subscribe(this.handleReadyChange);
        this.profileMenuReady = ko.observable(false);
        this.profileMenuReadySubscription = this.profileMenuReady.subscribe(this.handleReadyChange);

        this.editingCriticalFields = ko.observable(ClientSession.user.editingCriticalFields);

        this.securityService = new SecurityService();
        this.meaningfulUseConfigured = ko.observable(false);
        this.meaningfulUseConfiguration();
        this.settingsSubmittedSubscription = PubSub.subscribe(Subscriptions.App.SettingsSubmitted,
            (msg: any) => {
                this.meaningfulUseConfiguration();
            });
    }

    afterRenderProcess = () => {
        $(document).foundation('offcanvas', 'reflow');
    }

    clearBindings() {
        $('nav').accessibleDropDownClear();
    }

    setupBindings() {
        $('nav').accessibleDropDown();
    }

    getHelp() {
        //This doesn't need to do anything in the Login screen.
        //If we remove the Router reference, we prevent unused components from getting compiled. - CS:12/4/18
        return false;
    }

    async logout() {
        await RootStore.dispatch('logout');
    }

    goHome() {
        PubSub.publish(Subscriptions.App.GoHome, {});
    }

    dispose() {
        PubSub.unsubscribe(this.settingsSubmittedSubscription);
    }

    private handleReadyChange = () => {
        if (this.facilityMenuReady() && this.profileMenuReady()) {
            setTimeout(this.setupBindings, 500);
        } else {
            this.clearBindings();
        }
    }

    private meaningfulUseConfiguration() {
        this.securityService.meaningfulUseConfiguration().then((muConfig: boolean) => {
            this.meaningfulUseConfigured(muConfig);
        });
    }

    redirectToFacilityAdmin = () => {
        PubSub.publish(Subscriptions.App.RedirectPage, "#/facilityAdmin");
    }

    redirectToNHSAdmin = () => {
        PubSub.publish(Subscriptions.App.RedirectPage, "#/nhsAdmin");
    }
}

export var viewModel = TopNavigationViewModel;